<ds-modal
  [fullScroll]="true"
  [heading]="'overview.account-selector.which-account' | translate"
  [size]="'large'"
  closeCaption="{{ 'global.cta.close' | translate }}"
>
  <div body class="d-flex flex-row flex-wrap accounts-container">
    @for (account of accounts; track account) {
      <div class="d-flex flex-column">
        @if (account?.isSuspendedAccount) {
          <ng-container
            [ngTemplateOutlet]="accountStatusLabel"
            [ngTemplateOutletContext]="{
              variant: 'secondary',
              icon: 'error-outlined',
              copy: 'account-suspended',
            }"
          >
          </ng-container>
        }
        @if (account?.isCancelledAccount) {
          <ng-container
            [ngTemplateOutlet]="accountStatusLabel"
            [ngTemplateOutletContext]="{
              variant: 'tertiary',
              icon: 'error-outlined',
              copy: 'account-cancelled',
            }"
          >
          </ng-container>
        }
        <a
          (click)="selectAccount(account?.accountNumber)"
          [icon]="'account'"
          [variant]="'pill'"
          ds-chip
          [class.ds-corners-bottom]="account?.isSuspendedAccount || account?.isCancelledAccount"
          [class.ds-brcolor-yellow]="account?.isSuspendedAccount"
          [class.ds-brcolor-red]="account?.isCancelledAccount"
        >
          <span class="d-flex flex-column">
            <span class="account-name">
              <span class="ellipsis">{{ account?.firstName }} {{ account?.lastName }}</span>
            </span>
            <span>{{ account?.accountNumber }}</span>
          </span>
        </a>
      </div>
    }
  </div>
</ds-modal>

<ng-template #accountStatusLabel let-variant="variant" let-icon="icon" let-copy="copy">
  <span ds-label [variant]="variant">
    <ds-icon [name]="icon"></ds-icon>
    {{ 'overview.account-selector.' + copy | translate }}
  </span>
</ng-template>
